import React, {useEffect, useState} from "react";
import { db } from "../firebase_conf";
import { getDocs, query, where, collection, Timestamp, orderBy } from "firebase/firestore";

const AnnualReport = () => {
  const [data, setData] = useState({});
  const [annual, setAnnualReport] = useState(null);
  useEffect(() => {
    document.body.style.color = "black";
    document.body.style.background = "white";
    const currentYear = new Date().getFullYear();
    const ytd = Timestamp.fromDate(new Date(currentYear,0, 1));
    const getData = async () => {
      const q = query(
        collection(db, "admin_reports"),
        where("timestamp", ">", ytd), orderBy("timestamp")
      );
      const querySnapshot = await getDocs(q);
      let filtered_record = [];
      querySnapshot.forEach((doc) => {
        filtered_record.push({ ...doc.data(), id: doc.id });
      });
      setData(filtered_record);
      // console.log(filtered_record);
    };

    getData();
  }, []);

  useEffect(() => {
    if (Object.entries(data).length !== 0) {
      let annual_report = {
        "jan": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "feb": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "mar": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "apr": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "may": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "jun": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "jul": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "aug": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "sept": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "oct": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "nov": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
        "dec": {
          'total':0,
          'male':0,
          'female':0,
          'rhu':0,
          'rv': 0,
          'truck':0,
          'manlift':0
        },
      }
      data.forEach(el => {
        const current_month = new Date(el.timestamp.toDate()).getMonth();
        switch(current_month){
          case 0:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.jan.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.jan.female += 1;
            }
            annual_report.jan.total = annual_report.jan.male + annual_report.jan.female;
            if(el.assisted_to_rhu){
              annual_report.jan.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.jan.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.jan.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.jan.manlift += parseInt(el.manlift);
            }
            break;
          case 1:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.feb.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.feb.female += 1;
            }
            annual_report.feb.total = annual_report.feb.male + annual_report.feb.female;
            if(el.assisted_to_rhu){
              annual_report.feb.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.feb.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.feb.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.feb.manlift += parseInt(el.manlift);
            }
            break;
          case 2:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.mar.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.mar.female += 1;
            }
            annual_report.mar.total = annual_report.mar.male + annual_report.mar.female;
            if(el.assisted_to_rhu){
              annual_report.mar.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.mar.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.mar.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.mar.manlift += parseInt(el.manlift);
            }
            break;
          case 3:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.apr.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.apr.female += 1;
            }
            annual_report.apr.total = annual_report.apr.male + annual_report.apr.female;
            if(el.assisted_to_rhu){
              annual_report.apr.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.apr.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.apr.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.apr.manlift += parseInt(el.manlift);
            }
            break;   
          case 4:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.may.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.may.female += 1;
            }
            annual_report.may.total = annual_report.may.male + annual_report.may.female;
            if(el.assisted_to_rhu){
              annual_report.may.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.may.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.may.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.may.manlift += parseInt(el.manlift);
            }
            break;   
          case 5:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.jun.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.jun.female += 1;
            }
            annual_report.jun.total = annual_report.jun.male + annual_report.jun.female;
            if(el.assisted_to_rhu){
              annual_report.jun.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.jun.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.jun.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.jun.manlift += parseInt(el.manlift);
            }
            break;   
          case 6:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.jul.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.jul.female += 1;
            }
            annual_report.jul.total = annual_report.jul.male + annual_report.jul.female;
            if(el.assisted_to_rhu){
              annual_report.jul.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.jul.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.jul.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.jul.manlift += parseInt(el.manlift);
            }
            break;  
          case 7:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.aug.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.aug.female += 1;
            }
            annual_report.aug.total = annual_report.aug.male + annual_report.aug.female;
            if(el.assisted_to_rhu){
              annual_report.aug.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.aug.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.aug.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.aug.manlift += parseInt(el.manlift);
            }
            break;   
          case 8:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.sept.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.sept.female += 1;
            }
            annual_report.sept.total = annual_report.sept.male + annual_report.sept.female;
            if(el.assisted_to_rhu){
              annual_report.sept.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.sept.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.sept.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.sept.manlift += parseInt(el.manlift);
            }
            break;  
          case 9:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.oct.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.oct.female += 1;
            }
            annual_report.oct.total = annual_report.oct.male + annual_report.oct.female;
            if(el.assisted_to_rhu){
              annual_report.oct.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.oct.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.oct.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.oct.manlift += parseInt(el.manlift);
            }
            break;   
          case 10:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.nov.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.nov.female += 1;
            }
            annual_report.nov.total = annual_report.nov.male + annual_report.nov.female;
            if(el.assisted_to_rhu){
              annual_report.nov.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.nov.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.nov.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.nov.manlift += parseInt(el.manlift);
            }
            break;
          case 11:
            if(el.gender && el.gender.toLowerCase() === 'male'){
              annual_report.dec.male += 1;
            }else if(el.gender && el.gender.toLowerCase() === 'female'){
              annual_report.dec.female += 1;
            }
            annual_report.dec.total = annual_report.dec.male + annual_report.dec.female;
            if(el.assisted_to_rhu){
              annual_report.dec.rhu += parseInt(el.assisted_to_rhu);
            }
            if(el.rv){
              annual_report.dec.rv += parseInt(el.rescue_vehicle);
            }
            if(el.truck){
              annual_report.dec.truck += parseInt(el.truck);
            }
            if(el.manlift){
              annual_report.dec.manlift += parseInt(el.manlift);
            }
            break;    
        }
      })
      setAnnualReport(annual_report);
    }
  }, [data]);

  useEffect(()=> {
    if(annual){
      window.print();
    }
  }, [annual])
  return (
    <>
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={{ display: "inline-flex", gap: "50px", margin: "auto" }}>
          <div>
            <img
              src="/paracale_logo.jpg"
              alt="Logo"
              width={50}
              style={{ marginTop: "15px" }}
            ></img>
          </div>
          <div style={{ marginBottom: "13px" }}>
            <p style={{ margin: 0 }}>Republic of the Philippines</p>
            <p style={{ margin: 0 }}>Province of Camarines Norte</p>
            <p style={{ margin: 0 }}>Municipality of Paracale</p>
          </div>
          <div>
            <img
              src="/paracale_logo_1.jpg"
              alt="Logo"
              width={55}
              style={{ marginTop: "15px" }}
            ></img>
          </div>
        </div>
        <h3 style={{ margin: 0 }}>
          MUNICIPAL DISASTER RISK REDUCTION AND MANAGEMENT OFFICE
        </h3>
        <h3>RESCUE OPERATIONS REPORT {new Date().getFullYear()}</h3>
      </div>
      <table
        style={{
          border: "1px solid",
          width: "100%",
          borderCollapse: "collapse",
          padding: "5px",
        }}
      >
        <tbody>
          <tr>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}} rowSpan={2}>
              <b>Month </b>
            </td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}} colSpan={3}><b>Rescue Operations</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}rowSpan={2}><b>Assist to RHU</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}} colSpan={3}><b>Other Assist Services</b></td>
          </tr>
          <tr>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Total</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Male</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Female</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>RV</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Truck</b></td>
            <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Manlift</b></td>
          </tr>
          {annual && (
            <>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>January</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>February</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.feb.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>March</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.mar.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>April</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.apr.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>May</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.may.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>June</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jun.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>July</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jul.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>August</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.aug.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>September</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.sept.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>October</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.oct.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>November</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.nov.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>December</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.dec.manlift}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}><b>Total</b></td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.total+annual.feb.total+annual.mar.total+annual.apr.total+annual.may.total+annual.jun.total+annual.jul.total+annual.aug.total+annual.sept.total+annual.oct.total+annual.nov.total+annual.dec.total}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.male+annual.feb.male+annual.mar.male+annual.apr.male+annual.may.male+annual.jun.male+annual.jul.male+annual.aug.male+annual.sept.male+annual.oct.male+annual.nov.male+annual.dec.male}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.female+annual.feb.female+annual.mar.female+annual.apr.female+annual.may.female+annual.jun.female+annual.jul.female+annual.aug.female+annual.sept.female+annual.oct.female+annual.nov.female+annual.dec.female}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.rhu+annual.feb.rhu+annual.mar.rhu+annual.apr.rhu+annual.may.rhu+annual.jun.rhu+annual.jul.rhu+annual.aug.rhu+annual.sept.rhu+annual.oct.rhu+annual.nov.rhu+annual.dec.rhu}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.rv+annual.feb.rv+annual.mar.rv+annual.apr.rv+annual.may.rv+annual.jun.rv+annual.jul.rv+annual.aug.rv+annual.sept.rv+annual.oct.rv+annual.nov.rv+annual.dec.rv}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.truck+annual.feb.truck+annual.mar.truck+annual.apr.truck+annual.may.truck+annual.jun.truck+annual.jul.truck+annual.aug.truck+annual.sept.truck+annual.oct.truck+annual.nov.truck+annual.dec.truck}</td>
                <td style={{ padding: "5px", border: "1px solid", textAlign:'center'}}>{annual.jan.manlift+annual.feb.manlift+annual.mar.manlift+annual.apr.manlift+annual.may.manlift+annual.jun.manlift+annual.jul.manlift+annual.aug.manlift+annual.sept.manlift+annual.oct.manlift+annual.nov.manlift+annual.dec.manlift}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <div style={{display:'flex', marginTop:'20px'}}>
        <div style={{width:'50%'}}>
          Prepared by:
          <br/>
          <br/>
          <br/>
          <p style={{margin:0}}><b>Charles Gian Catapang</b></p>
          <p style={{margin:0}}>Operation and Warning Officer</p>
          </div>
        <div style={{width:'50%'}}>
          Noted:
          <br/>
          <br/>
          <br/>
          <p style={{margin:0}}><b>Ricky P. Manarang, RN,LPT,MSDRM</b></p>
          <p style={{margin:0}}>MDRRMO</p>
        </div>
      </div>
    </>
  );
};

export default AnnualReport;
